import React, {useEffect} from "react";
// reactstrap components
import {
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Media,
    Nav,
    Navbar,
    UncontrolledDropdown,
} from "reactstrap";
import drop from "../../assets/img/icons/header/dropdown.png"
import {getAuth, signOut} from "firebase/auth";

const AdminNavbar = (props) => {
    const auth = getAuth();

    useEffect(() => {
    }, [])

    const styles = {
        navStyle: {
            // backgroundColor: '#04A1FE',
            color: '#000000',
            padding: "2px",
            borderRadius: '50px'
        },
        textColor: {
            color: '#000000'
        },
        lineHeight: {
            lineHeight: '5px',
            fontSize: "15px"
        },
        fontSize: {
            fontSize: '3rem'
        }
    }


    return (
        <>

            <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">

                <Container fluid>
                        <h1 style={styles.fontSize} className="custom-font">{props.brandText}</h1>
                    {/*<Form className="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">*/}
                    {/*  <FormGroup className="mb-0">*/}
                    {/*    <InputGroup className="input-group-alternative">*/}
                    {/*      <InputGroupAddon addonType="prepend">*/}
                    {/*        <InputGroupText>*/}
                    {/*          <i className="fas fa-search" />*/}
                    {/*        </InputGroupText>*/}
                    {/*      </InputGroupAddon>*/}
                    {/*      <Input placeholder="Search" type="text" />*/}
                    {/*    </InputGroup>*/}
                    {/*  </FormGroup>*/}
                    {/*</Form>*/}
                    <Nav style={styles.navStyle} className="align-items-center d-none d-md-flex justify-content-between" >
                        <UncontrolledDropdown nav>
                            <DropdownToggle className="pr-0 b" nav>
                                <Media className="align-items-center ">
                                    <Media className="ml-2 d-none d-lg-block mx-2">
                                        <span style={styles.lineHeight} className="mb-0 text-dark custom-font">
                                            {
                                                props.signedInUser.name ? props.signedInUser.name :
                                                    (props.signedInUser.email && props.signedInUser.email.split('@')[0])
                                            }
                                            <img alt="" className="mt-2 ml-2" src={drop}/>
                                        </span>
                                    </Media>
                                    {/* className="avatar avatar-sm mx-1" */}
                                    <span className="mx-2">
                                        {/* <img
                                            alt="..."
                                            src={loginImg}
                                        /> */}
                                    </span>

                                </Media>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-arrow" right>
                                <DropdownItem className="noti-title" header tag="div">
                                    <h6 className="text-overflow m-0">Welcome!</h6>
                                </DropdownItem>
                                <DropdownItem href="#pablo" onClick={(e) => {
                                    e.preventDefault();
                                    signOut(auth).then(() => {
                                        props.setRouteState("");
                                        // Sign-out successful.
                                    }).catch((error) => {
                                        // An error happened.
                                    });
                                }}>
                                    <i className="ni ni-user-run" />
                                    <span>Logout</span>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </Nav>
                </Container>
            </Navbar>
        </>
    );
};

export default AdminNavbar;
